import { isOnFnaPhase } from 'quick-quote/fna/selectors'
import { hasFirstYearLstu } from 'quick-quote/product-investment/coverage-plan/selectors'
import {
  canProceedToFundAndCoveragePlan,
  canProceedToInvestmentBenefitIllustration,
  canProceedToLstuFundAllocation,
  canProceedToPremiumCalculation,
  canProceedToRiskQuestionnaire,
  canProceedToRiskQuestionnaireV2,
  canProceedToRppFundAllocation,
  blockSelectedFund,
} from 'quick-quote/product-investment/journey-control-selectors'
import { canProceedPerfectLifeBenefitIllustration } from 'quick-quote/product-perfect-life/coverage-plan/selectors'
import { canProceedSukhapabDekDeeBenefitIllustration } from 'quick-quote/product-sukhapabdekdee/coverage-plan/selectors'
import { canProceedRetirementBenefitIllustration } from 'quick-quote/product-retirement/coverage-plan/selectors'
import { canProceedBumnanReadyBenefitIllustration } from 'quick-quote/product-bumnan-ready/coverage-plan/selectors'
import {
  canProceedToInsuredInformation,
  isIlinkProduct,
  canProceedToIlpSaleSheet,
} from 'quick-quote/product-selection/selectors'
import { canProceedToBenefitIllustration } from 'quick-quote/product-whole-life/coverage-plan/selectors'
import { canProceedToBenefitIllustration as canProductPAProceedToBenefitIllustration } from 'quick-quote/product-pa/coverage-plan/selectors'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'
import {
  canProceedToSelectPolicyOwner,
  canProceedToNormalTab,
  canProceedToSelectPolicyOwner as canProceedToInsuredInformationWithValidateMaturity,
} from 'quick-quote/product-sio/selectors'
import { isApiRequesting } from 'quick-quote/selectors/partner-selector'
import TABS from '../../../../../core/data-model/constants/tab-messages'
import { PATH, qqPath, ROUTE_PATH } from '../../../../constants/path'

export const wholeLife = (state) => {
  return {
    path: qqPath(PATH.WHOLE_LIFE),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.WHOLE_LIFE.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.WHOLE_LIFE.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.WHOLE_LIFE.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.WHOLE_LIFE.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.WHOLE_LIFE.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.WHOLE_LIFE.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const protection = (state) => {
  return {
    path: qqPath(PATH.PROTECTION),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.PROTECTION.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.PROTECTION.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.PROTECTION.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.PROTECTION.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.PROTECTION.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.PROTECTION.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const flexiHealth = (state) => {
  return {
    path: qqPath(PATH.FLEXI_HEALTH),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.FLEXI_HEALTH.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.FLEXI_HEALTH.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.FLEXI_HEALTH.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.FLEXI_HEALTH.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.FLEXI_HEALTH.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.FLEXI_HEALTH.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}
export const healthTopping = (state) => {
  return {
    path: qqPath(PATH.HEALTH_TOPPING),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.HEALTH_TOPPING.PRODUCT_SELECTION),
        id: 'product-selection',
        hide: isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.HEALTH_TOPPING.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.HEALTH_TOPPING.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.HEALTH_TOPPING.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.HEALTH_TOPPING.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.HEALTH_TOPPING.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}
export const health = (state) => {
  return {
    path: qqPath(PATH.HEALTH),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.HEALTH.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.HEALTH.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.HEALTH.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.HEALTH.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.HEALTH.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.HEALTH.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const ihealthyUltra = (state) => {
  return {
    path: qqPath(PATH.IHEALTHY_ULTRA),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.IHEALTHY_ULTRA.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.IHEALTHY_ULTRA.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.IHEALTHY_ULTRA.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.IHEALTHY_ULTRA.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.IHEALTHY_ULTRA.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.IHEALTHY_ULTRA.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const lifeReady = (state) => {
  return {
    path: qqPath(PATH.LIFE_READY),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.LIFE_READY.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.LIFE_READY.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.LIFE_READY.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.LIFE_READY.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.LIFE_READY.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.LIFE_READY.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const lifeProtectPlus = (state) => {
  return {
    path: qqPath(PATH.LIFE_PROTECT_PLUS),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.LIFE_PROTECT_PLUS.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.LIFE_PROTECT_PLUS.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.LIFE_PROTECT_PLUS.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.LIFE_PROTECT_PLUS.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.LIFE_PROTECT_PLUS.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.LIFE_PROTECT_PLUS.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const productSIO = (state) => {
  return {
    path: qqPath(PATH.PRODUCT_SIO),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.PRODUCT_SIO.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MATURITY_VALIDATE,
        path: qqPath(ROUTE_PATH.PRODUCT_SIO.MATURITY_VALIDATE),
        id: 'maturity-validate',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.PRODUCT_SIO.INSURED_INFORMATION),
        id: 'insured-information',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToInsuredInformationWithValidateMaturity(state) ||
          !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.PRODUCT_SIO.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToInsuredInformationWithValidateMaturity(state) ||
          !canProceedToCoveragePlan(state) ||
          isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.PRODUCT_SIO.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToInsuredInformationWithValidateMaturity(state) ||
          !canProceedToBenefitIllustration(state) ||
          isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.PRODUCT_SIO.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.PRODUCT_SIO.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const productGIO_PREUW = (state) => {
  return {
    path: qqPath(PATH.PRODUCT_GIO_PREUW),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.PRODUCT_GIO_PREUW.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MATURITY_VALIDATE,
        path: qqPath(ROUTE_PATH.PRODUCT_GIO_PREUW.MATURITY_VALIDATE),
        id: 'maturity-validate',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.PRODUCT_GIO_PREUW.INSURED_INFORMATION),
        id: 'insured-information',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToInsuredInformationWithValidateMaturity(state) ||
          !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.PRODUCT_GIO_PREUW.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToInsuredInformationWithValidateMaturity(state) ||
          !canProceedToCoveragePlan(state) ||
          isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.PRODUCT_GIO_PREUW.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToInsuredInformationWithValidateMaturity(state) ||
          !canProceedToBenefitIllustration(state) ||
          isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.PRODUCT_GIO_PREUW.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.PRODUCT_GIO_PREUW.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const mrta = (state) => {
  return {
    path: qqPath(PATH.MRTA),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.MRTA.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.MRTA.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.MRTA.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.MRTA.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.MRTA.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.MRTA.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const pa = (state) => {
  return {
    path: qqPath(PATH.PA),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.PA.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.PA.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.PA.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.PA.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProductPAProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.PA.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.PA.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const investmentV2 = (state) => {
  return {
    path: qqPath(PATH.INVESTMENT),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.INVESTMENT.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.PRODUCT_DETAIL,
        path: qqPath(ROUTE_PATH.INVESTMENT.ILP_SALE_SHEET),
        id: 'ilp-sale-sheet',
        disabled: isOnFnaPhase(state) || !canProceedToIlpSaleSheet(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.INVESTMENT.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.PREMIUM,
        path: qqPath(ROUTE_PATH.INVESTMENT.COVERAGE_PLAN),
        id: 'premium',
        disabled: isOnFnaPhase(state) || !canProceedToPremiumCalculation(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.RISK,
        path: qqPath(ROUTE_PATH.INVESTMENT.RISK_QUESTIONNAIRE),
        id: 'invest',
        disabled: isOnFnaPhase(state) || !canProceedToRiskQuestionnaireV2(state),
        component: null,
      },
      {
        title: isIlinkProduct(state) ? TABS.RPP_FUND : TABS.FUND,
        path: qqPath(ROUTE_PATH.INVESTMENT.FUND_ALLOCATION),
        id: 'fund',
        disabled: isOnFnaPhase(state) || !canProceedToRppFundAllocation(state) || blockSelectedFund(state),
        component: null,
      },
      {
        title: TABS.LSTU_FUND,
        path: qqPath(ROUTE_PATH.INVESTMENT.LSTU_FUND_ALLOCATION),
        id: 'fund-lstu',
        disabled: isOnFnaPhase(state) || !canProceedToLstuFundAllocation(state),
        component: null,
        hide: !hasFirstYearLstu(state),
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.INVESTMENT.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToInvestmentBenefitIllustration(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.INVESTMENT.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.INVESTMENT.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const investment = (state) => {
  return {
    path: qqPath(PATH.INVESTMENT),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.INVESTMENT.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.PRODUCT_DETAIL,
        path: qqPath(ROUTE_PATH.INVESTMENT.ILP_SALE_SHEET),
        id: 'ilp-sale-sheet',
        disabled: isOnFnaPhase(state) || !canProceedToIlpSaleSheet(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.INVESTMENT.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.RISK,
        path: qqPath(ROUTE_PATH.INVESTMENT.RISK_QUESTIONNAIRE),
        id: 'invest',
        disabled: isOnFnaPhase(state) || !canProceedToRiskQuestionnaire(state),
        component: null,
      },
      {
        title: TABS.FUND,
        path: qqPath(ROUTE_PATH.INVESTMENT.FUND_ALLOCATION),
        id: 'fund',
        disabled: isOnFnaPhase(state) || !canProceedToFundAndCoveragePlan(state),
        component: null,
      },
      {
        title: TABS.PREMIUM,
        path: qqPath(ROUTE_PATH.INVESTMENT.COVERAGE_PLAN),
        id: 'premium',
        disabled: isOnFnaPhase(state) || !canProceedToFundAndCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.INVESTMENT.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToFundAndCoveragePlan(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.INVESTMENT.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.INVESTMENT.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const loan = (state) => {
  return {
    path: qqPath(PATH.LOAN),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.LOAN.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.LOAN.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.LOAN.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.LOAN.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.LOAN.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.LOAN.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}
export const saving = (state) => {
  return {
    path: qqPath(PATH.SAVING),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.SAVING.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.SAVING.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.SAVING.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.SAVING.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.SAVING.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.SAVING.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}
export const lifeSavePro = (state) => {
  return {
    path: qqPath(PATH.LIFE_SAVE_PRO),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.LIFE_SAVE_PRO.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.LIFE_SAVE_PRO.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.LIFE_SAVE_PRO.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.LIFE_SAVE_PRO.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.LIFE_SAVE_PRO.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.LIFE_SAVE_PRO.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const retirement = (state) => {
  return {
    path: qqPath(PATH.RETIREMENT),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.RETIREMENT.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.RETIREMENT.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.RETIREMENT.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.RETIREMENT.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedRetirementBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.RETIREMENT.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.RETIREMENT.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const bumnanReady = (state) => {
  return {
    path: qqPath(PATH.BUMNAN_READY),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.BUMNAN_READY.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.BUMNAN_READY.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.BUMNAN_READY.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.BUMNAN_READY.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedBumnanReadyBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.BUMNAN_READY.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.BUMNAN_READY.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const perfectLife = (state) => {
  return {
    path: qqPath(PATH.PERFECT_LIFE),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.PERFECT_LIFE.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.PERFECT_LIFE.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.PERFECT_LIFE.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.PERFECT_LIFE.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedPerfectLifeBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.PERFECT_LIFE.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.PERFECT_LIFE.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const sukhapabDekDee = (state) => {
  return {
    path: qqPath(PATH.SUKHAPABDEKDEE),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.SUKHAPABDEKDEE.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.SUKHAPABDEKDEE.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.SUKHAPABDEKDEE.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.SUKHAPABDEKDEE.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedSukhapabDekDeeBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.SUKHAPABDEKDEE.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.SUKHAPABDEKDEE.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const s7cc = (state) => {
  return {
    path: qqPath(PATH.S7CC),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.S7CC.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MATURITY_VALIDATE,
        path: qqPath(ROUTE_PATH.S7CC.MATURITY_VALIDATE),
        // id: 'insured-information',
        id: 'maturity-validate',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.SELECT_POLICY_OWNER,
        path: qqPath(ROUTE_PATH.S7CC.SELECT_POLICY_OWNER),
        // id: 'insured-information',
        id: 'select-policy-owner',
        disabled: isOnFnaPhase(state) || !canProceedToSelectPolicyOwner(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.S7CC.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToNormalTab(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.S7CC.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToNormalTab(state) ||
          !canProceedToCoveragePlan(state) ||
          isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.S7CC.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled:
          isOnFnaPhase(state) ||
          !canProceedToNormalTab(state) ||
          !canProceedToBenefitIllustration(state) ||
          isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.S7CC.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.S7CC.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        component: null,
      },
    ],
  }
}

export const termLife = (state) => {
  return {
    path: qqPath(PATH.TERM_LIFE),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.TERM_LIFE.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.TERM_LIFE.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.TERM_LIFE.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state) || isApiRequesting(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.TERM_LIFE.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state) || isApiRequesting(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.TERM_LIFE.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.TERM_LIFE.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const indexLinked = (state) => {
  return {
    path: qqPath(PATH.INDEX_LINKED),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.INDEX_LINKED.PRODUCT_SELECTION),
        id: 'product-selection',
        disabled: isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: qqPath(ROUTE_PATH.INDEX_LINKED.INSURED_INFORMATION),
        id: 'insured-information',
        disabled: isOnFnaPhase(state) || !canProceedToInsuredInformation(state),
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: qqPath(ROUTE_PATH.INDEX_LINKED.COVERAGE_PLAN),
        id: 'calculate-premium',
        disabled: isOnFnaPhase(state) || !canProceedToCoveragePlan(state),
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: qqPath(ROUTE_PATH.INDEX_LINKED.BENEFIT_ILLUSTRATION),
        id: 'benefit-illustration',
        disabled: isOnFnaPhase(state) || !canProceedToBenefitIllustration(state),
        component: null,
        analyticsEventType: 'BIEvent',
      },
      {
        title: TABS.NEED_AND_GAP_ANALYSIS,
        path: qqPath(ROUTE_PATH.INDEX_LINKED.NEED_AND_GAP_ANALYSIS),
        id: 'need',
        disabled: false,
        hide: !isOnFnaPhase(state),
        component: null,
      },
      {
        title: TABS.MARKET_CONDUCTS,
        path: qqPath(ROUTE_PATH.INDEX_LINKED.MARKET_CONDUCTS),
        id: 'market-conduct',
        hide: !isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
    ],
  }
}

export const qqProductSelection = (state) => {
  return {
    path: qqPath(PATH.PRODUCT_SELECTION),
    tabs: [
      {
        title: TABS.PRODUCT_SELECTION,
        path: qqPath(ROUTE_PATH.PRODUCT_SELECTION),
        id: 'product-selection',
        hide: isOnFnaPhase(state),
        disabled: false,
        component: null,
      },
      {
        title: TABS.INSURED_PERSON,
        path: '',
        id: 'insured-information',
        hide: isOnFnaPhase(state),
        disabled: true,
        component: null,
      },
      {
        title: TABS.CALCULATE_PREMIUM,
        path: '',
        id: 'calculate-premium',
        hide: isOnFnaPhase(state),
        disabled: true,
        component: null,
      },
      {
        title: TABS.BENEFIT_ILLUSTRATION,
        path: '',
        id: 'benefit-illustration',
        hide: isOnFnaPhase(state),
        disabled: true,
        component: null,
        analyticsEventType: 'BIEvent',
      },
    ],
  }
}

export default (state) => [
  wholeLife(state),
  investmentV2(state),
  loan(state),
  healthTopping(state),
  health(state),
  ihealthyUltra(state),
  saving(state),
  protection(state),
  lifeSavePro(state),
  flexiHealth(state),
  retirement(state),
  bumnanReady(state),
  perfectLife(state),
  sukhapabDekDee(state),
  s7cc(state),
  termLife(state),
  indexLinked(state),
  lifeReady(state),
  lifeProtectPlus(state),
  mrta(state),
  pa(state),
  productSIO(state),
  productGIO_PREUW(state),
  qqProductSelection(state),
]
